const HUMAN_FEEDBACK_NODE_TYPES = new Set([
  "HumanInTheLoopNode",
  "HumanInTheLoopV2",
  "CreateTaskNode",
  "CreateTaskV2",
]);

export function isHumanFeedbackNodeType(nodeType: string | undefined) {
  return !!nodeType && HUMAN_FEEDBACK_NODE_TYPES.has(nodeType);
}

export function isTaskNodeType(nodeType: string | undefined) {
  return nodeType === "CreateTaskNode" || nodeType === "CreateTaskV2";
}

export function isSubflowNodeType(nodeType: string | undefined) {
  return nodeType === "InvokeSubflowNode" || nodeType === "InvokeSubflowV2Node";
}

/** Node types that legitimately wait on a person: the human-feedback nodes
 *  themselves plus a subflow whose child is paused on one. */
export function canAwaitHumanFeedback(nodeType: string | undefined) {
  return isHumanFeedbackNodeType(nodeType) || isSubflowNodeType(nodeType);
}

const PAUSABLE_NODE_STATUSES = new Set([
  "stopped",
  "running",
  "payment_required",
]);

/** The status the run panel renders for a node. Only a node that genuinely
 *  waits on a person may read as awaiting feedback (DEV-1683: a user Stop used
 *  to put the "Go to task manager" banner on any in-flight node); every other
 *  suspended node reads as paused. */
export function deriveNodeUiStatus(
  nodeStatus: string | undefined,
  runStatus: string | undefined,
  nodeType: string | undefined
): string | undefined {
  // A V1 human-review node reports `errored` while its run pauses, so the
  // run-level wait is inherited by anything not already finished.
  const finished = nodeStatus === "succeeded" || nodeStatus === "skipped";
  const awaiting =
    nodeStatus === "awaiting_human_feedback" ||
    (runStatus === "awaiting_human_feedback" && !finished);
  if (awaiting && canAwaitHumanFeedback(nodeType)) {
    return "awaiting_human_feedback";
  }
  if (nodeStatus === "paused" || nodeStatus === "awaiting_human_feedback") {
    return "stopped";
  }
  if (
    runStatus === "stopped" &&
    nodeStatus &&
    PAUSABLE_NODE_STATUSES.has(nodeStatus)
  ) {
    return "stopped";
  }
  return nodeStatus;
}
